import {
    apiRequest,
    diklatTrainingList,
    diklatCreate
} from "../../../../../services/adapters/kepegawaian/diklatService"

class CreateRepository {

    fetchTrainingList = async (query, cancelToken) => {
        return await apiRequest("get", diklatTrainingList, {
            params: query,
            cancelToken: cancelToken
        }, true)
    }

    fetchCreate = async (query) => {
        return await apiRequest("post", diklatCreate, {
            body: query
        }, true)
    }

}

export default CreateRepository